import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { authApi } from '~services/api/auth';
import { WebPushService } from '~services/webpush';

import type { RootState } from '../index';
export const pushNotificationsInit = createListenerMiddleware();

// when on client - start push notifications init
pushNotificationsInit.startListening({
	matcher: isAnyOf(
		authApi.endpoints.login.matchFulfilled,
		authApi.endpoints.googleLogin.matchFulfilled,
		authApi.endpoints.registerGoogle.matchFulfilled,
		authApi.endpoints.register.matchFulfilled
	),
	effect: (action, listenerApi) => {
		if (typeof window === 'undefined') {
			return;
		}
		const {
			auth: {
				info: { id },
			},
		} = listenerApi.getState() as RootState;
		//TODO: add cases login/logout
		const dispatch = listenerApi.dispatch;
		const { askPermission } = WebPushService(dispatch);
		listenerApi.unsubscribe();
		function askPushNotificationPermissions() {
			void askPermission(id);
		}

		document?.body.addEventListener('click', askPushNotificationPermissions, {
			passive: true,
			once: true,
		});
	},
});
